import React from "react";

const LineCrudTableSearchModal = ({
                                        setFindModal,

                                        listClientsByNumDocument,
                                        listClientsByMail,
                                        listClientsByName,

                                        validateInputOfSearch}) => {


                                

    const handleChange = (e) => {
        setFindModal({[e.target.name]: e.target.value});

    }
    const handleSubmit = (e) => { //click en buscar
        var optionSelected = parseInt(document.querySelector('#busquedaModal').value);
        var valueInput = document.querySelector('#findModal').value;

        console.log("optionSelected : "+optionSelected);
        console.log("valueInput : "+valueInput);


        e.preventDefault();
        if (optionSelected === 2) {
            listClientsByNumDocument(valueInput);
        }else if (optionSelected === 1) {
            listClientsByName(valueInput);
        }else if (optionSelected === 0) {
            validateInputOfSearch();
        }      
    }

    return (
        <div>    
            <div className="row mb-2">
                <h6>Busqueda de Clientes:</h6>
            </div>
            <div className="table-responsive rounded-3 d-flex justify-content-center" style={{border:'1px solid black', paddingTop:'10px'}}>
                <>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <select id="busquedaModal" className="form-select" aria-label="Default select example">
                                    <option value="0">Seleccione</option>
                                    <option value="1">Nombre</option>
                                    <option value="2">Número de documento</option>
                                </select>
                            </div>
                            <div className="col">
                                <input type="text" className="form-control" id="findModal" name="findModal" onChange={handleChange}/>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center" style={{paddingTop:'10px', paddingBlock:'10px'}}>
                            <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Buscar</button>
                        </div>
                    </div>
                </>
            </div>
        </div>
    );
}
export default LineCrudTableSearchModal;